import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FormInput,
  FormButton,
  InputWrap,
  LoginWrap,
  LogForm,
  ShowBtn,
} from './LoginForm.styled';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const LoginForm = () => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleLogin = e => {
    e.preventDefault();
    if (password === process.env.REACT_APP_PASSWORD_FORM) {
      console.log('Correct password, proceeding to login');
      localStorage.setItem('isAuthenticated', 'true');
      navigate('/Calculator');
    } else {
      console.log('Incorrect password');
      alert('Неправильный пароль!');
    }
  };
  const handleTogglePassword = e => {
    e.preventDefault();
    e.stopPropagation();
    setShowPassword(!showPassword);
  };
  return (
    <LoginWrap>
      <LogForm onSubmit={handleLogin}>
        <InputWrap>
          <label>Password</label>
          <FormInput
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
          <ShowBtn type="button" onClick={e => handleTogglePassword(e)}>
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </ShowBtn>
        </InputWrap>
        <FormButton type="submit">Login</FormButton>
      </LogForm>
    </LoginWrap>
  );
};

export default LoginForm;
